export const getErrors = errors => {
  let errorList = {
    hasCommentError: false,
    hasMediaError: false,
    hasYouTubeError: false
  };

  errors.map(({ errorMessage }) => {
    let key;
    const err = errorMessage.toLowerCase();

    switch (true) {
      case err.includes('comment'):
        key = 'hasCommentError';
        break;
      case err.includes('photo'):
        key = 'hasMediaError';
        break;
      case err.includes('youtube'):
        key = 'hasYouTubeError';
        break;
      case err.includes('alias'):
        key = 'hasAliasError';
        break;
    }

    errorList[key] = true;
  });

  return errorList;
};
